import React, { useState } from 'react';

const ApiTest = () => {
  const [accessToken] = useState("eyJhbGciOiJSUzI1NiIsImtpZCI6IkE1MDBFQUQ5NkY3MjJBNUNBRjdGRDI1OURCQjMwRjQwOEFEMjM2MjEiLCJ4NXQiOiJwUURxMlc5eUtseXZmOUpaMjdNUFFJclNOaUUiLCJ0eXAiOiJhdCtqd3QifQ.eyJpc3MiOiJodHRwczovL2F1dGguc2luY2FwcGFpLmNvbS8iLCJleHAiOjE3ODE5Mzc4NzQsImlhdCI6MTc1MDQwMTg3NCwiYXVkIjoiU2luY2FwcCIsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwgcm9sZXMgU2luY2FwcCBvZmZsaW5lX2FjY2VzcyIsImp0aSI6ImUzZjdiMTU5LWRhODItNGIzNC04NDY5LTZhZjZlZDJkZmJjNiIsInN1YiI6IjRjMjAxYmE3LWM4OGMtZjlhYS03MjY0LTNhMTkwN2M5OWJmZCIsInNlc3Npb25faWQiOiJlYzQyNzNkNS0yM2JmLTRjYzktOGFmMy0xMTRiMzJmMzJjMDIiLCJ1bmlxdWVfbmFtZSI6Im9ncmVuY2k1MCIsIm9pX3Byc3QiOiJTaW5jYXBwX01vYmlsZV9UZXN0Iiwib2lfYXVfaWQiOiJjYTFlZjVmZi0yNDM5LTBlOGMtOTVkOS0zYTFhM2Q2NmM0NTEiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJvZ3JlbmNpNTAiLCJnaXZlbl9uYW1lIjoiWVNhYcSwTSIsImZhbWlseV9uYW1lIjoiWWFhU8SwTSIsInJvbGUiOiJrdWxsYW5pY2kiLCJlbWFpbCI6Im9ncmVuY2lfNTBAc2luY2FwcC5jb20iLCJlbWFpbF92ZXJpZmllZCI6IkZhbHNlIiwicGhvbmVfbnVtYmVyIjoiMTIzNDU2Nzg5IiwicGhvbmVfbnVtYmVyX3ZlcmlmaWVkIjoiRmFsc2UiLCJjbGllbnRfaWQiOiJTaW5jYXBwX01vYmlsZV9UZXN0Iiwib2lfdGtuX2lkIjoiOWRiNWJiZDMtNzk4ZS04NTFlLTY1M2QtM2ExYTllNDFkMWJlIn0.fGn_IbrSL1fWAk845W-8lBP4U4hUS3CR1oGVmd5NsUKhgw5Z7UUIjHQAzmZ1iAJJMUvtz47ba1mz1JIf7XUcGpj6SlPhxS0dV58igTO5KvpsWIiVbKTjqKlBB5fU2WgiH4dQ7b9utUbDX5Ji-p9MODXzYhPCiUdLmrE8z-yrErSD2EsPKYyK3QFMt1rvK1Bh_-SS5hK2ekVS1Xg34SR6nBH5FS7BZm3QFICrKLvtA7Um-6uhSxtPXY33fAx6Wh0RRIcc-fCBDwISiqeksim4yEaeTYybNmDAZ3CI8nd3h2rWLjM6iJbRWsX4kZLzIp5V4A9Dsv-E8vQJjKv_svd4og");
  const [firebaseResult, setFirebaseResult] = useState<any>(null);
  const [questionsResult, setQuestionsResult] = useState<any>(null);
  const [firebaseLoading, setFirebaseLoading] = useState(false);
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [firebaseError, setFirebaseError] = useState<string | null>(null);
  const [questionsError, setQuestionsError] = useState<string | null>(null);

  const testData = {
    studyTask: {
      id: "68548579b4219e039e3120a9",
      userAccountId: "4c201ba7-c88c-f9aa-7264-3a1907c99bfd",
      date: "2025-06-19",
      title: "Test Sınavı",
      entityId: null,
      resourceId: "4ba96ed8-1224-4508-8392-49d3fd14fd68",
      assignerType: "Student",
      assignedByAccountId: "f6eb03e6-2356-adc5-bd27-3a1907c99d75",
      status: "Assigned",
      order: 0,
      taskType: "Regular",
      params: {
        totalTime: 1200,
        nQuestions: 20
      },
      mode: "TimeTest"
    }
  };

  const getFirebaseToken = async () => {
    setFirebaseLoading(true);
    setFirebaseError(null);
    setFirebaseResult(null);
    
    try {
      const response = await fetch('https://api.sincappai.com/api/WhiteboardFirebase/GetToken', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          deviceId: `web_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          deviceName: 'Web Test',
          userId: "4c201ba7-c88c-f9aa-7264-3a1907c99bfd"
        }),
        mode: 'cors',
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setFirebaseResult(data);
    } catch (error) {
      setFirebaseError(error instanceof Error ? error.message : 'Unknown error');
      console.error('Firebase token error:', error);
    } finally {
      setFirebaseLoading(false);
    }
  };

  const getQuestions = async () => {
    setQuestionsLoading(true);
    setQuestionsError(null);
    setQuestionsResult(null);
    
    try {
      const response = await fetch('https://api.sincappai.com/api/app/study-action/exam-questions', {
        method: 'POST',
        headers: {
          'accept': 'text/plain',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(testData.studyTask),
        mode: 'cors',
        credentials: 'include'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();
      setQuestionsResult(data);
      console.log('Full response:', data);
    } catch (error) {
      setQuestionsError(error instanceof Error ? error.message : 'Unknown error');
      console.error('Questions error:', error);
    } finally {
      setQuestionsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Sincapp API Test</h1>
        
        {/* Access Token Section */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Access Token</h2>
          <div className="bg-gray-100 p-3 rounded font-mono text-xs break-all">
            {accessToken.substring(0, 50)}...
          </div>
        </div>

        {/* Firebase Token Test */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Adım 1: Firebase Token Al</h2>
          <button
            onClick={getFirebaseToken}
            disabled={firebaseLoading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-400"
          >
            {firebaseLoading ? 'Yükleniyor...' : 'Firebase Token Al'}
          </button>
          
          {firebaseError && (
            <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
              Hata: {firebaseError}
            </div>
          )}
          
          {firebaseResult && (
            <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
              <p className="font-semibold mb-2">Başarılı!</p>
              <pre className="text-xs overflow-auto">{JSON.stringify(firebaseResult, null, 2)}</pre>
            </div>
          )}
        </div>

        {/* Questions Test */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Adım 2: Soruları Al</h2>
          <button
            onClick={getQuestions}
            disabled={questionsLoading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-400"
          >
            {questionsLoading ? 'Yükleniyor...' : 'Soruları Al'}
          </button>
          
          {questionsError && (
            <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
              Hata: {questionsError}
            </div>
          )}
          
          {questionsResult && (
            <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
              <p className="font-semibold mb-2">Başarılı!</p>
              <p>Ders Grupları: {(questionsResult as any).coursesGroups?.length || 0}</p>
              <p>İlk grup: {(questionsResult as any).coursesGroups?.[0]?.groupName || 'N/A'}</p>
              <details className="mt-2">
                <summary className="cursor-pointer text-sm">Tam yanıt (tıkla)</summary>
                <pre className="text-xs overflow-auto mt-2">{JSON.stringify(questionsResult, null, 2)}</pre>
              </details>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApiTest;